import { AnyAction } from 'redux';
import { createListLoadingReducer, listInitialState } from './utils';
import { Payment } from '@/types';
import * as actions from '../actions';
import reduceReducers from 'reduce-reducers';

const initialState = {
    ...listInitialState
}

const paymentsReducer = createListLoadingReducer<Payment>('PAYMENTS');

const metaReducer = (state = listInitialState, action: AnyAction) => {
    switch (action.type) {
        case actions.EXPORT_PAYMENTS.REQUEST: {
            return {
                ...state,
                exporting: true
            };
        }
        case actions.EXPORT_PAYMENTS.SUCCESS: {
            return {
                ...state,
                exporting: false
            };
        }
        case actions.EXPORT_PAYMENTS.FAILURE: {
            return {
                ...state,
                exporting: false
            };
        }
        default:
            return state;
    }
}

export default reduceReducers<any>(initialState, paymentsReducer, metaReducer);
